import React, { useState, createContext } from "react";

export const BlogContext = createContext();

export const BlogProvider = (props) => {
  const [posts, setPosts] = useState([
    {
      id: "db_not_connected",
      title: "Database not connected",
      subtitle: "",
      text: "Database not connected",
      buttonLabel: "",
      dark: true,
      primary: true,
      link: "home",
    },
    {
      id: "events_hero",
      title: "Events",
      subtitle: "",
      text: "Let me show you my world of music in person.",
      buttonLabel: "",
      dark: true,
      primary: true,
      link: "home",
    },
  ]);
  return (
    <BlogContext.Provider value={[posts, setPosts]}>
      {props.children}
    </BlogContext.Provider>
  );
};
